import { useState } from "react";
import { useNotify } from "ra-core";
import { Button } from "@/components/ui/button";
import {
  requestSuggestion,
  type CopilotContext,
  type Suggestion,
} from "./copilotSuggest";
import { HelpTooltip } from "../help/HelpTooltip";

/** Apoyo en vivo (Bloque C2, paso 5): botón manual, NUNCA automático por fragmento. */
export const CopilotSuggestionPanel = ({
  consentId,
  transcript,
  context,
}: {
  consentId: number;
  transcript: string;
  context: CopilotContext;
}) => {
  const notify = useNotify();
  const [suggestion, setSuggestion] = useState<Suggestion | null>(null);
  const [busy, setBusy] = useState(false);

  const ask = async () => {
    setBusy(true);
    const { data, error } = await requestSuggestion(
      consentId,
      transcript,
      context,
    );
    if (error) notify(error, { type: "error" });
    else setSuggestion(data);
    setBusy(false);
  };

  return (
    <div className="flex flex-col gap-2 rounded-md border p-2">
      <div className="flex items-center justify-between gap-2">
        <b className="inline-flex items-center gap-1 text-sm">
          Sugerencia
          <HelpTooltip topic="calls.suggestion" />
        </b>
        <Button size="sm" variant="outline" disabled={busy} onClick={ask}>
          {busy ? "Pensando…" : "Sugerir ahora"}
        </Button>
      </div>
      {suggestion && (
        <div className="flex flex-col gap-1 text-sm">
          {suggestion.objecion && (
            <p>
              <b>Objeción:</b> {suggestion.objecion}
            </p>
          )}
          {suggestion.respuesta && <p>{suggestion.respuesta}</p>}
          {suggestion.siguiente_pregunta && (
            <p className="text-muted-foreground">
              Pregunta siguiente: {suggestion.siguiente_pregunta}
            </p>
          )}
        </div>
      )}
    </div>
  );
};
